module.exports = __webpack_public_path__ + "img/banner02.a91cfc6f.jpg";